import { A } from '@solidjs/router'
import { Show, createMemo } from 'solid-js'
import InputProfileListPage from '../../lib/event/InputRouter/Pages/InputProfileListPage'
import { setModalMenu } from '../../rx/shared/ModalMenu/ModalMenuSignal'
import getSessionUserId from '../../rx/shared/session/getSessionUserId'
import SignInButton from '../SignInButton'
import SignOutButton from '../SignOutButton'
import ListItem from './ListItem'
import type { MainMenuObj } from './MainMenuObj.type'
import ModalMenuDeviceSettings from './ModalMenuDeviceSettings'

const ModalMenuMain: MainMenuObj = {
  dname: 'Menu',
  fn() {
    const gamesPath = createMemo(() => {
      const authId = getSessionUserId()
      if (authId) {
        return `/games?player_profile_id=${authId}`
      }
      return "/games"
    })

    return <>
      <ul class="list-group list-group-flush">
        <Show when={!getSessionUserId()}>
          <ListItem>
            <SignInButton />
          </ListItem>
        </Show>
        <ListItem>
          <A href={gamesPath()}>Games</A>
        </ListItem>
        <ListItem>
          <A href="/maps">Maps</A>
        </ListItem>
        <Show when={getSessionUserId()}>
          <ListItem>
            <A href="/auth/profile">Account</A>
          </ListItem>
        </Show>
        <ListItem>
          <A href="/army-painter">Army Painter</A>
        </ListItem>
        <ListItem>
          <A href="/codex">Codex</A>
        </ListItem>
        <ListItem>
          <a href="#" onClick={() => setModalMenu(ModalMenuDeviceSettings)}>Device Settings</a>
        </ListItem>
        <ListItem>
          <a href="#" onClick={() => setModalMenu(InputProfileListPage)}>Controls</a>
        </ListItem>
      </ul>
      <hr />
      <Show when={getSessionUserId()}>
        <ListItem>
          <SignOutButton />
        </ListItem>
      </Show>
    </>
  }
}

export default ModalMenuMain
